<lh-header></lh-header>
<div class="content">
    <router-outlet #routerOutlet="outlet"></router-outlet>
    <lh-footer></lh-footer>
</div>